import { getDatabookSheet, type DatabookSheetPreview } from "@/lib/api/databook";
import { DATABOOK_SHEET_PAGE_SIZE } from "./databookPreviewState";

// Mapping filters need every row. Source sheets retain the API's normal paging.
export async function loadDatabookPreview(
  ...args: Parameters<typeof getDatabookSheet>
): Promise<DatabookSheetPreview> {
  if (args[1] !== "Mapping") return getDatabookSheet(...args);
  const [projectId, sheetName, , , , versionId] = args;
  const first = await getDatabookSheet(projectId, sheetName, 0, [], [], versionId);
  if (first.returned_row_count === undefined || first.returned_row_count >= first.row_count) return first;
  const pages = [first];
  // Bound parallel requests and keep every page pinned to the selected version.
  for (let offset = DATABOOK_SHEET_PAGE_SIZE; offset < first.row_count; offset += DATABOOK_SHEET_PAGE_SIZE * 3) {
    const offsets = [offset, offset + DATABOOK_SHEET_PAGE_SIZE, offset + DATABOOK_SHEET_PAGE_SIZE * 2]
      .filter(value => value < first.row_count);
    pages.push(...await Promise.all(offsets.map(value =>
      getDatabookSheet(projectId, sheetName, value, [], [], versionId))));
  }
  if (pages.some(page => page.row_count !== first.row_count)
    || pages.reduce((count, page) => count + (page.returned_row_count ?? 0), 0) !== first.row_count) {
    throw new Error("Could not load all Mapping rows. Please retry.");
  }
  // The paged preview retains global row coordinates and a shared style table.
  return {
    ...first,
    row_offset: 0,
    returned_row_count: first.row_count,
    rows: pages.flatMap(page => page.rows),
    cells: pages.flatMap(page => page.cells),
    merges: pages.flatMap(page => page.merges),
  };
}
